/* Bower — hero carousel
 *
 * Click or Arrow-key on a thumb activates the matching frame and
 * updates the live frame-meta line. Crossfade is owned by CSS;
 * this script only swaps `.is-active` classes.
 */
(function () {
  const root = document.querySelector('.bower-hero');
  if (!root) return;

  const thumbs = root.querySelectorAll('.bower-hero__thumb');
  const frames = root.querySelectorAll('.bower-hero__frame');
  const meta   = root.querySelector('.bower-hero__meta');
  const total  = thumbs.length;
  if (!thumbs.length || !frames.length || !meta) return;

  function activate(i) {
    thumbs.forEach((t, idx) => {
      const on = idx === i;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    frames.forEach((f, idx) => f.classList.toggle('is-active', idx === i));
    const label = thumbs[i].dataset.label || '';
    const num = String(i + 1).padStart(2, '0');
    meta.innerHTML = '<b>' + num + ' / ' + String(total).padStart(2, '0') + '</b>&nbsp;' + label;
  }

  thumbs.forEach((t, i) => {
    t.addEventListener('click', () => activate(i));
    t.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        const n = (i + 1) % total;
        thumbs[n].focus();
        activate(n);
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        const n = (i - 1 + total) % total;
        thumbs[n].focus();
        activate(n);
      }
    });
  });
})();
